import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../hooks/useContent';
import HeroSection from '../components/HeroSection';
import UeberUns from '../components/UeberUns';
import HighlightsList from '../components/HighlightsList';

export default function Startseite() {
  const { content, loading, error } = useContent();

  if (loading) return <div style={styles.loading}>Inhalte werden geladen...</div>;
  if (error) return <div style={styles.errorBox}>Inhalte konnten nicht geladen werden.<br /><small>{error}</small></div>;
  if (!content) return null;

  return (
    <main>
      <HeroSection
        heading={content.hero?.heading}
        subheading={content.hero?.subheading}
      />

      <UeberUns
        heading={content.ueberUns?.heading}
        text={content.ueberUns?.text}
      />

      <HighlightsList highlights={content.highlights} />

      {/* Kontakt & CTA Bereich */}
      {content.contact && (
        <section style={styles.contactSection}>
          <div style={styles.contactInner}>
            <div style={styles.contactCard}>
              <h2 style={styles.contactHeading}>Kontakt & Anreise</h2>
              <div style={styles.contactGrid}>
                <div style={styles.contactInfo}>
                  <div style={styles.contactRow}>
                    <span style={styles.contactIcon}>📍</span>
                    <div>
                      <strong style={styles.contactLabel}>{content.contact.name}</strong>
                      <span style={styles.contactValue}>{content.contact.address}</span>
                    </div>
                  </div>
                  <div style={styles.contactRow}>
                    <span style={styles.contactIcon}>📞</span>
                    <div>
                      <strong style={styles.contactLabel}>Telefon</strong>
                      <a href={`tel:${content.contact.phone}`} style={styles.contactLink}>{content.contact.phone}</a>
                    </div>
                  </div>
                  <div style={styles.contactRow}>
                    <span style={styles.contactIcon}>✉️</span>
                    <div>
                      <strong style={styles.contactLabel}>E-Mail</strong>
                      <a href={`mailto:${content.contact.email}`} style={styles.contactLink}>{content.contact.email}</a>
                    </div>
                  </div>
                  <div style={styles.contactRow}>
                    <span style={styles.contactIcon}>🌐</span>
                    <div>
                      <strong style={styles.contactLabel}>Website</strong>
                      <span style={styles.contactValue}>www.camping-spirkenhof.at</span>
                    </div>
                  </div>
                </div>
                <div style={styles.ctaBox}>
                  <p style={styles.ctaText}>Bereit für Ihren nächsten Urlaub?</p>
                  <Link to="/buchung" style={styles.ctaBtn}>Jetzt Buchungsanfrage stellen</Link>
                  <Link to="/galerie" style={styles.ctaBtnSecondary}>Galerie ansehen</Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerInner}>
          <p style={styles.footerText}>
            © {new Date().getFullYear()} Camping Spirkenhof · <a href="mailto:info@camping-spirkenhof.at" style={styles.footerLink}>info@camping-spirkenhof.at</a>
          </p>
          <p style={styles.footerText} style={{ opacity: 0.5, marginTop: '0.3rem', fontSize: '0.8rem' }}>
            www.camping-spirkenhof.at
          </p>
        </div>
      </footer>
    </main>
  );
}

const styles = {
  loading: { textAlign: 'center', padding: '6rem 2rem', fontFamily: "'Nunito', Arial, sans-serif", color: '#40916c', fontSize: '1.1rem' },
  errorBox: { textAlign: 'center', padding: '4rem 2rem', fontFamily: "'Nunito', Arial, sans-serif", color: '#dc3545' },

  contactSection: { backgroundColor: '#f0f7f2', padding: '5rem 1.5rem' },
  contactInner: { maxWidth: '1000px', margin: '0 auto' },
  contactCard: { backgroundColor: 'white', borderRadius: '20px', padding: '3rem', boxShadow: '0 4px 30px rgba(45,106,79,0.12)' },
  contactHeading: { color: '#1b4332', fontFamily: "'Nunito', Arial, sans-serif", fontSize: '2rem', fontWeight: '800', marginBottom: '2rem', textAlign: 'center' },
  contactGrid: { display: 'flex', gap: '3rem', flexWrap: 'wrap', justifyContent: 'center' },
  contactInfo: { display: 'flex', flexDirection: 'column', gap: '1.2rem', flex: '1 1 280px' },
  contactRow: { display: 'flex', gap: '1rem', alignItems: 'flex-start' },
  contactIcon: { fontSize: '1.3rem', flexShrink: 0, marginTop: '0.1rem' },
  contactLabel: { display: 'block', fontFamily: "'Nunito', Arial, sans-serif", fontWeight: '700', color: '#1b4332', fontSize: '0.9rem' },
  contactValue: { display: 'block', fontFamily: "'Nunito', Arial, sans-serif", color: '#4a6558', fontSize: '0.95rem', marginTop: '0.1rem' },
  contactLink: { display: 'block', fontFamily: "'Nunito', Arial, sans-serif", color: '#40916c', fontSize: '0.95rem', textDecoration: 'none', fontWeight: '600', marginTop: '0.1rem' },
  ctaBox: { flex: '1 1 240px', display: 'flex', flexDirection: 'column', gap: '0.85rem', justifyContent: 'center', alignItems: 'stretch' },
  ctaText: { color: '#4a6558', fontFamily: "'Nunito', Arial, sans-serif", textAlign: 'center', fontSize: '1rem', fontWeight: '600', marginBottom: '0.3rem' },
  ctaBtn: { display: 'block', backgroundColor: '#2d6a4f', color: 'white', textDecoration: 'none', padding: '0.95rem 1.5rem', borderRadius: '12px', fontWeight: '800', fontFamily: "'Nunito', Arial, sans-serif", fontSize: '1rem', textAlign: 'center', boxShadow: '0 4px 15px rgba(45,106,79,0.3)' },
  ctaBtnSecondary: { display: 'block', backgroundColor: 'transparent', color: '#2d6a4f', textDecoration: 'none', padding: '0.9rem 1.5rem', borderRadius: '12px', fontWeight: '700', fontFamily: "'Nunito', Arial, sans-serif", fontSize: '0.95rem', textAlign: 'center', border: '2px solid #d8f3dc' },

  footer: { backgroundColor: '#1b4332', padding: '2rem 1.5rem' },
  footerInner: { maxWidth: '1100px', margin: '0 auto', textAlign: 'center' },
  footerText: { color: 'rgba(255,255,255,0.65)', fontFamily: "'Nunito', Arial, sans-serif", fontSize: '0.9rem' },
  footerLink: { color: 'rgba(255,255,255,0.8)', textDecoration: 'none' },
};
